import type { HowItWorkItem } from '~/components/pages/directions/how-it-work-section/how-it-works.types'

const HOW_IT_WORK_ARENDA_AUDIOGUIDE: HowItWorkItem = {
    cards: [
        {
            id: 1,
            title: '',
            description:
                '1. Аудиотреки заранее записываются в&nbsp;микрофон и&nbsp;загружаются в&nbsp;аудиогиды',
            alt: 'Загрузка аудиотреков на ноутбук',
            width: 880,
            height: 472,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/audio-tracks-upload-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/audio-tracks-upload.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/audio-tracks-upload-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/audio-tracks-upload.webp',
        },
        {
            id: 2,
            title: '',
            description:
                '2. Экскурсантам раздают аудиогиды при входе на&nbsp;экспозицию или в&nbsp;музей',
            alt: 'Экскурсанты получают аудиогиды',
            width: 880,
            height: 472,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/audioguide-distribution-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/audioguide-distribution.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/audioguide-distribution-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/audioguide-distribution.webp',
        },
        {
            id: 3,
            title: '',
            description:
                '3. Посетитель слушает экскурсию через динамик или наушники, в&nbsp;соответствии с&nbsp;номерами экспонатов (в&nbsp;автоматическом или ручном режиме)',
            alt: 'Посетитель слушает экскурсию через динамик или наушники',
            width: 880,
            height: 472,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/listening-tour-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/listening-tour.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/listening-tour-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/listening-tour.webp',
        },
    ],
    video: {
        title: 'Как используется',
        name: 'Как в работе',
        description: 'Аудиогиды для музеев и&nbsp;улицы в&nbsp;руках слушателя',
        width: 400,
        height: 267,
        video_preview:
            '/assets/images/usage/audioguide/jpg-png/in-museum-2.jpg',
        video_preview_webp:
            '/assets/images/usage/radioguide/webp/in-museum-2.webp',
        duration: '0:45',
        link: 'ed64b10278b999b09feab52ad385b0b3',
    },
}

export default HOW_IT_WORK_ARENDA_AUDIOGUIDE
